import OspInputNumber from './OspInputNumber.vue';

export default OspInputNumber;



// WEBPACK FOOTER //
// ./src/components/OspInputNumber/index.js